/**
 * Created by zzy on 2019/7/23.
 */
import AppMenu from './AppMenu.vue'
export default AppMenu



// WEBPACK FOOTER //
// ./src/components/appMenu/index.js